// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Emoji_tooltip__O2IOi"};